import React,{useState,useEffect} from 'react'
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { noticedata } from '../../../utils/NoticePageApi';
import $ from 'jquery'
import axios from "axios";
import {Modal} from 'react-bootstrap'
const LatestSliderNoticePage = (props) => {
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '18px',
      };

      var navigate = useNavigate()
      
      $(function noticehover() {
      
        let x,y;
        $(".noticebox").on('mouseenter', function(e) {
          x = e.pageX - $(this).offset().left;
          y = e.pageY - $(this).offset().top;
          $(this).find("span").css({
            top: y,
            left: x
          });
        });
        $(".noticebox").on('mouseout', function(e) {
          x = e.pageX - $(this).offset().left;
          y = e.pageY - $(this).offset().top;
          $(this).find("span").css({
            top: y,
            left: x
          });
        });
        
      });

      const [modalheading,setmodalheading] = useState("")
      const [modaldate,setmodaldate] = useState("")
      const [modalbody,setmodalbody] = useState("")

      const handleNoticeSinglePage=(myitem)=>{
        setshow(true)
        setmodalheading(myitem.header)
        setmodaldate(myitem.noticeDate)
        setmodalbody(myitem.body)
      }
  
    const headers = {
      "X-localization": localStorage.getItem("lan"),
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Methods": "*",
      "Access-Control-Max-Age": 3600,
    };
    const [myresponse, setmyResponse] = useState([]);
    useEffect(() => {

      const fetchLatestNotice = async () => {
        try {
          const myresponse = await axios.get("https://sass.britishstandardschool.com/api/Public/LatestNotice", {}, headers);
          setmyResponse(myresponse.data)
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
      };
  
      fetchLatestNotice();
      console.log(myresponse);
    }, []);
    const [activeKey, setActiveKey] = useState(null);
    const handleAccordionToggle = (eventKey) => {
      setActiveKey(eventKey);
      // eventKey == activeKey ? null : 
  };
  const [show,setshow] = useState(false)
  const handleClose=()=>{
    setshow(false)
  }
  return (
    <>
         <div className="noticemobile" data-aos="fade-up" data-aos-duration="2000">
            <div className={props.title?"heading":"d-none"}>
                        <h4>{props.title?props.title:"Notice"}</h4>
                    </div>
                    <div className="mobilecontainer">
                  <h5>{props.subtitle}</h5>
                </div>
                <Slider {...settings}>
                {
                    myresponse.map((item,key)=>{
                      // let trimmedString= item.paragraph.substr(0, 38)
                      return(
                        <div className="noticebox noticeboxleft m-auto" onClick={()=>handleNoticeSinglePage(item)}>
                        <span></span>
                        <div className="noticeheading">
                        <h4>{item.header}</h4>
                            </div>
                                <p className='mainparagraph'>
                               
                                {/* {trimmedString}... */}
                                {item.noticeBody}
                                </p>
                                <div className="lastrow d-flex">
                                <img src="./assets/images/icons/cal.png" alt="" /> 
                                <p>{item.noticeDate}</p>

                                </div>
                        </div>
                      )
                    })
                  }
                <div className="noticebox noticeboxlast m-auto">
                <span></span>
                <div className="ntcwrapper ">
                    <div className="carditemwrapper">
                    
                    <p style={{fontSize:"12px"}}>No more</p>
                    </div>
                </div> 
                </div>
                   
                    </Slider>
            </div>

            <Modal  dialogClassName="mymodalltnt" show={show} onHide={handleClose} backdrop="static"
              keyboard={false}>
                
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Notice</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{marginBottom:"40px"}}>
                  {
                    <>
                    <div className="noticeheading">
                    <h4>{modalheading}</h4>
                        </div>
                        <div className="lastrow d-flex align-items-center">
                        <img style={{height:"18px",marginRight:"10px"}} src="./assets/images/icons/cal.png" alt="" /> 
                        <p>{modaldate}</p>

                        </div>
                        <p className='mainparagraph' style={{marginTop:"20px"}}>
                          {modalbody}hello man
                        </p>
                    </>
                  }
                </Modal.Body>
                  
                
                
              </Modal>

    </>
  )
}

export default LatestSliderNoticePage